import React from 'react';
import { FlaskLoader } from './FlaskLoader';

export const LoadingFallback: React.FC = () => {
    return (
        <div data-testid="loading-fallback" className="min-h-[400px] flex items-center justify-center">
            <div className="glass-card p-8 rounded-xl text-center">
                <FlaskLoader text="טוען..." size="xl" />
            </div>
        </div>
    );
};
